import React, { Component } from 'react';
import PropTypes from 'prop-types';
import "../style/popup-menu.scss";


export const PopupMenuButton = (props) => {
    const { onClick, itemId } = props;
    return <div className="popup-menu-button" onClick={(event) => onClick(itemId, event)} data-item-id={itemId}>
        <div className="popup-menu-image" />
    </div>
}
export class PopupMenu extends Component {

    constructor(props){
        super(props)
        this.componentDidUpdate = this.componentDidUpdate.bind(this)
        this.onScroll = this.onScroll.bind(this)
    }
    componentDidUpdate(prevProps,prevState){
        if(this.props.visibility){
            this.popupMenu.focus();
        }
    }
    componentDidMount(){
        window.addEventListener('scroll', this.onScroll, true)
    }
    componentWillUnmount(){
        window.removeEventListener('scroll', this.onScroll)
    }
    onScroll(){
        this.props.hideMenu()
    }
    render() {
        const currentStyle = {
            top: this.props.position.y,
            left: this.props.position.x,
            visibility: this.props.visibility ? 'visible' : 'hidden',
            zIndex: 10,
            position: 'fixed'
        };

        return (
            <div className="popup-menu" style={currentStyle} onBlur={this.props.hideMenu} tabIndex="1" ref={(popupMenu)=>{this.popupMenu=popupMenu;}}>
                {this.props.menuItems.map(menuItem => {
                    return (
                        <a className="popup-menu-item" onClick={menuItem.action} style={{display:"block"}}
                             key={`menu.item.${menuItem.id}`}>
                             {menuItem.id}
                        </a>
                    );
                })}
            </div>
        );
    }
};

PopupMenu.propTypes = {
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            action: PropTypes.func
        })
    ),
    position: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
    }),
    visibility: PropTypes.bool
};
PopupMenuButton.propsTypes = {
    onClick: PropTypes.func.isRequired,
    id: PropTypes.any.isRequired
}


// WEBPACK FOOTER //
// ./src/common/components/popup-menu.jsx